import HELPER from '@/app/utils/HELPER';
import { getRotationInfo, getCurrency } from '@/app/utils/helpers';
import { setFontWeight } from '@/app/utils/settingFontWeight';

import { getWidthPercentage } from '@/app/utils/helpers';
export default function ($element, $activePanel, _this, $self, moduleName, style, screenType) {
  switch (moduleName) {
    case 'Popup':
      var height = HELPER.getValueFromCSS($self, style, 'height', screenType, '.module-wrap');
      var width = HELPER.getValueFromCSS($self, style, 'width', screenType, '.module-wrap');
      var fullScreen = $activePanel.find(`#fullScreen-${screenType}`).val();
      if (fullScreen == '1') {
        width = '100%';
        height = '100%';
      } else {
        if (!width) {
          width = '';
        }
        if (!height) {
          height = '';
        }
      }
      if (width == '100%' && height == '100%') {
        $activePanel.find(`#fullScreen-${screenType}`).val('1').attr('value', '1').trigger('value-change');
      } else {
        $activePanel.find(`#fullScreen-${screenType}`).val(0).attr('value', 0).trigger('value-change');
      }
      $activePanel.find('input[name="height"]').val(height).attr('value', height).trigger('value-change');
      $activePanel.find('input[name="width"]').val(width).attr('value', width).trigger('value-change');

      var $selfModule = $self.find('.module');
      var padding = HELPER.getValueFromCSS($selfModule, style, 'padding', screenType, '.module');
      if (padding == '') {
        padding = $selfModule.css('padding');
      }
      $activePanel.find('input[name="padding"]').val(padding).attr('value', padding).trigger('value-change');

      // Button close
      var classBtnClose = '.gf-closePopup';
      var $selfBtn = $self.find(classBtnClose);

      var btnCloseFill = HELPER.getValueFromCSS($selfBtn, style, 'fill', screenType, classBtnClose);
      if (btnCloseFill == '') {
        btnCloseFill = HELPER.rgb2hex($selfBtn.css('fill'));
      }
      $activePanel
        .find('input[name="closeBtnColor"]')
        .val(btnCloseFill)
        .attr('value', btnCloseFill)
        .trigger('value-change');

      var btnCloseBg = HELPER.getValueFromCSS($selfBtn, style, 'background-color', screenType, classBtnClose);
      if (btnCloseBg == '') {
        btnCloseBg = HELPER.rgb2hex($selfBtn.css('background-color'));
      }
      $activePanel.find('input[name="closeBtnBg"]').val(btnCloseBg).attr('value', btnCloseBg).trigger('value-change');

      var btnClosePosY = HELPER.getValueFromCSS($selfBtn, style, 'top', screenType, classBtnClose);
      if (btnClosePosY == '') {
        btnClosePosY = $selfBtn.css('top');
      }
      $activePanel
        .find('input[name="closeBtnPosY"]')
        .val(btnClosePosY)
        .attr('value', btnClosePosY)
        .trigger('value-change');

      var btnClosePosX = HELPER.getValueFromCSS($selfBtn, style, 'right', screenType, classBtnClose);
      if (btnClosePosX == '') {
        btnClosePosX = $selfBtn.css('right');
      }
      $activePanel
        .find('input[name="closeBtnPosX"]')
        .val(btnClosePosX)
        .attr('value', btnClosePosX)
        .trigger('value-change');

      var btnCloseRadius = HELPER.getValueFromCSS($selfBtn, style, 'border-radius', screenType, classBtnClose);

      if (btnCloseRadius != '') {
        $activePanel
          .find('input[name="closeBtnRadius"]')
          .val(btnCloseRadius)
          .attr('value', btnCloseRadius)
          .trigger('value-change');
      }

      var btnCloseSize = HELPER.getValueFromCSS($selfBtn, style, 'width', screenType, classBtnClose);
      if (btnCloseSize == '') {
        btnCloseSize = $selfBtn.css('width');
      }

      $activePanel
        .find('input[name="closeBtnSize"]')
        .val(btnCloseSize)
        .attr('value', btnCloseSize)
        .trigger('value-change');

      // Button close icon
      var classBtnIconClose = '.gf-closePopup svg';
      var $selfBtnIcon = $self.find(classBtnIconClose);
      var btnCloseIconSize = HELPER.getValueFromCSS($selfBtnIcon, style, 'width', screenType, classBtnIconClose);
      if (btnCloseIconSize == '') {
        btnCloseIconSize = $selfBtnIcon.css('width');
      }
      $activePanel
        .find('input[name="closeBtnIconSize"]')
        .val(btnCloseIconSize)
        .attr('value', btnCloseIconSize)
        .trigger('value-change');
      break;

    case 'Video Bg':
      var backgroundImage = HELPER.getImageBg($self);
      $activePanel.find('#image').val(backgroundImage).attr('value', backgroundImage).trigger('value-change');
      break;

    case 'Google Map':
    case 'Google Maps':
      var height = HELPER.getValueFromCSS($self, style, 'height', screenType, '.gf_google-container');
      if (height == '') {
        height = $self[0].style.height;
      }
      $activePanel.find('input[name="height"]').val(height).attr('value', height).trigger('value-change');

      break;
    case '(P) File Upload': {
      const $targetSelector = $self ? $self.find('.gf_btn-upload') : $element.find('.gf_btn-upload');
      const $targetPreviewSelector = $self ? $self.find('.gf_file-upload') : $element.find('.gf_file-upload');
      const $targetSecondary = $targetSelector.find('.gf_btn-secondarytext');
      // Typography
      // font-size
      let fontSizeNumber = HELPER.getValueFromCSS($targetSelector, style, 'font-size', screenType);
      if (fontSizeNumber == '') {
        fontSizeNumber = $targetSelector.css('font-size');
      }
      $activePanel.find('#font-size').val(fontSizeNumber).attr('value', fontSizeNumber).trigger('value-change');

      // Secondary font-size
      let secondarySize = HELPER.getValueFromCSS(
        $targetSecondary,
        style,
        'font-size',
        screenType,
        '.gf_btn-secondarytext',
      );
      if (secondarySize == '') {
        secondarySize = $targetSecondary.css('font-size');
      }
      $activePanel.find('#secondarySize').val(secondarySize).attr('value', secondarySize).trigger('value-change');

      // Font family
      let fontFamily = HELPER.getValueFromCSS($targetSelector, style, 'font-family', screenType, '.gf_btn-upload');
      if (fontFamily == '') {
        fontFamily = $targetSelector.css('font-family');
      }
      fontFamily = jQuery.trim(fontFamily);
      $activePanel.find('#font').val(fontFamily).attr('value', fontFamily).trigger('value-change');

      // Secondary Font family
      let secondaryFont = HELPER.getValueFromCSS(
        $targetSecondary,
        style,
        'font-family',
        screenType,
        '.gf_btn-secondarytext',
      );
      if (secondaryFont == '') {
        secondaryFont = $targetSelector.css('font-family');
      }
      secondaryFont = jQuery.trim(secondaryFont);
      $activePanel.find('#secondaryFont').val(secondaryFont).attr('value', secondaryFont).trigger('value-change');

      // font-style
      // Italic
      let fontItalic = HELPER.getValueFromCSS($targetSelector, style, 'font-style', screenType, '.gf_btn-upload');
      if (fontItalic == '') {
        fontItalic = $targetSelector.css('font-style');
      }
      if (fontItalic != 'italic') {
        fontItalic = '';
      }
      // Secondary Italic
      let fontItalicSecondary = HELPER.getValueFromCSS(
        $targetSecondary,
        style,
        'font-style',
        screenType,
        '.gf_btn-secondarytext',
      );
      if (fontItalicSecondary == '') {
        fontItalicSecondary = $targetSecondary.css('font-style');
      }
      if (fontItalicSecondary != 'italic') {
        fontItalicSecondary = '';
      }

      // Bold
      let fontWeight = HELPER.getValueFromCSS($targetSelector, style, 'font-weight', screenType, '.gf_btn-upload');
      if (fontWeight == '') {
        fontWeight = $targetSelector.css('font-weight');
      }
      if (fontWeight != 'bold' && fontWeight != '700') {
        fontWeight = '';
      }
      if (fontWeight == '700') {
        fontWeight = 'bold';
      }
      // Secondary Bold
      let fontWeightSecondary = HELPER.getValueFromCSS(
        $targetSecondary,
        style,
        'font-weight',
        screenType,
        '.gf_btn-secondarytext',
      );
      if (fontWeightSecondary == '') {
        fontWeightSecondary = $targetSecondary.css('font-weight');
      }
      if (fontWeightSecondary != 'bold' && fontWeightSecondary != '700') {
        fontWeightSecondary = '';
      }
      if (fontWeightSecondary == '700') {
        fontWeightSecondary = 'bold';
      }

      // Underline
      let fontUnderline = HELPER.getValueFromCSS(
        $targetSelector,
        style,
        'text-decoration',
        screenType,
        '.gf_btn-upload',
      );
      if (fontUnderline == '') {
        fontUnderline = $targetSelector.css('text-decoration');
      }
      if (fontUnderline != 'underline') {
        fontUnderline = '';
      }
      // Secondary Underline
      let fontUnderlineSecondary = HELPER.getValueFromCSS(
        $targetSecondary,
        style,
        'text-decoration',
        screenType,
        '.gf_btn-secondarytext',
      );
      if (fontUnderlineSecondary == '') {
        fontUnderlineSecondary = $targetSecondary.css('text-decoration');
        if (fontUnderlineSecondary && fontUnderlineSecondary.includes('underline')) {
          fontUnderlineSecondary = 'underline';
        }
      }
      if (fontUnderlineSecondary != 'underline') {
        fontUnderlineSecondary = '';
      }
      const fontStyle = fontItalic + ',' + fontWeight + ',' + fontUnderline;
      $activePanel.find('#font-style').val(fontStyle).attr('value', fontStyle).trigger('value-change');
      const fontStyleSecondary = fontItalicSecondary + ',' + fontWeightSecondary + ',' + fontUnderlineSecondary;
      $activePanel
        .find('#secondaryFontStyle')
        .val(fontStyleSecondary)
        .attr('value', fontStyleSecondary)
        .trigger('value-change');

      // Text Transform
      let textTransform = HELPER.getValueFromCSS(
        $targetSelector,
        style,
        'text-transform',
        screenType,
        '.gf_btn-upload',
      );
      if (textTransform == undefined || textTransform == '') {
        textTransform = $targetSelector.css('text-transform');
      }
      $activePanel.find('#textTransform').val(textTransform).attr('value', textTransform).trigger('value-change');
      // Secondary Text Transform
      let textTransformSecondary = HELPER.getValueFromCSS(
        $targetSecondary,
        style,
        'text-transform',
        screenType,
        '.gf_btn-secondarytext',
      );
      if (textTransformSecondary == undefined || textTransformSecondary == '') {
        textTransformSecondary = $targetSecondary.css('text-transform');
      }
      $activePanel
        .find('#textTransform')
        .val(textTransformSecondary)
        .attr('value', textTransformSecondary)
        .trigger('value-change');

      // button color
      let btnColor = HELPER.getValueFromCSS($targetSelector, style, 'background-color', screenType, '.gf_btn-upload');
      if (btnColor == '') {
        btnColor = HELPER.rgb2hex($targetSelector.css('background-color'));
      }
      $activePanel.find('#button-color').val(btnColor).attr('value', btnColor).trigger('value-change');

      // button text color
      let btnTextColor = HELPER.getValueFromCSS($targetSelector, style, 'color', screenType, '.gf_btn-upload');
      if (btnTextColor == '') {
        btnTextColor = HELPER.rgb2hex($targetSelector.css('color'));
      }
      $activePanel.find('#color').val(btnTextColor).attr('value', btnTextColor).trigger('value-change');
      // Secondary button text color
      let secondaryTextColor = HELPER.getValueFromCSS(
        $targetSelector,
        style,
        'color',
        screenType,
        '.gf_btn-secondarytext',
      );
      if (secondaryTextColor == '') {
        secondaryTextColor = HELPER.rgb2hex($targetSelector.css('color'));
      }
      $activePanel
        .find('#secondaryColor')
        .val(secondaryTextColor)
        .attr('value', secondaryTextColor)
        .trigger('value-change');

      // Hover Options
      const btnColorHover = HELPER.getValueFromCSS(
        $targetSelector,
        style,
        'background-color',
        screenType,
        '.gf_btn-upload:hover',
      );
      $activePanel.find('#button-color-hover').val(btnColorHover).attr('value', btnColorHover).trigger('value-change');

      const colorHover = HELPER.getValueFromCSS($targetSelector, style, 'color', screenType, '.gf_btn-upload:hover');
      $activePanel.find('#color-hover').val(colorHover).attr('value', colorHover).trigger('value-change');

      // width
      let width = HELPER.getValueFromCSS($targetSelector, style, 'width', screenType, '.gf_btn-upload');
      if (width == '') {
        width = $targetSelector.css('width');
        if (width) {
          width = Math.ceil(parseFloat(width));
        }
      }
      const percentWidth = getWidthPercentage($targetSelector);
      if (percentWidth == 100) {
        width = percentWidth + '%';
      }
      $activePanel.find('input[name="width"]').val(width).attr('value', width).trigger('value-change');

      // height
      const height = HELPER.getValueFromCSS($targetSelector, style, 'height', screenType, '.gf_btn-upload');
      $activePanel.find('input[name="height"]').val(height).attr('value', height).trigger('value-change');

      // preview width
      let previewWidth = HELPER.getValueFromCSS(
        $targetPreviewSelector,
        style,
        'width',
        screenType,
        '.gf_upload-preview',
      );
      if (previewWidth == '') {
        previewWidth = $targetPreviewSelector.width();
        if (previewWidth) {
          previewWidth = Math.ceil(previewWidth) + 'px';
        }
      }
      const percent = getWidthPercentage($targetPreviewSelector);
      if (percent == 100) {
        previewWidth = percent + '%';
      }
      $activePanel
        .find('input[name="previewWidth"]')
        .val(previewWidth)
        .attr('value', previewWidth)
        .trigger('value-change');

      // preview height
      let previewHeight = HELPER.getValueFromCSS(
        $targetPreviewSelector,
        style,
        'height',
        screenType,
        '.gf_upload-preview',
      );
      if (previewHeight == '') {
        previewHeight = $targetPreviewSelector.find('.gf_upload-preview').height();
        if (previewHeight) {
          previewHeight = Math.ceil(previewHeight) + 'px';
        } else {
          previewHeight = '';
        }
      }
      $activePanel
        .find('input[name="previewHeight"]')
        .val(previewHeight)
        .attr('value', previewHeight)
        .trigger('value-change');

      // Button Color
      break;
    }
    case '(P) Stock Counter': {
      // width
      let width = HELPER.getValueFromCSS($element, style, 'width', screenType, '.module-wrap .module');
      const $module = $element.children('.module');
      if (width == '' || width == 'none') {
        width = $module.css('width');
      }
      let percentWidth = getWidthPercentage($module);
      if (percentWidth) {
        percentWidth += '%';
      }
      $activePanel.find('input[name="width"]').val(percentWidth).attr('value', percentWidth).trigger('value-change');
      break;
    }
    case 'Count Down':
    case 'Countdown Timer':
      /* Number */
      // font size
      var $selfNumber = $self.find('.module .num');
      var fontSizeNumber = HELPER.getValueFromCSS($selfNumber, style, 'font-size', screenType);
      if (fontSizeNumber == '') {
        fontSizeNumber = $selfNumber.css('font-size');
      }

      $activePanel.find('#number-size').val(fontSizeNumber).attr('value', fontSizeNumber).trigger('value-change');
      // Font family
      var fontFamilyNumber = HELPER.getValueFromCSS($selfNumber, style, 'font-family', screenType);

      fontFamilyNumber = jQuery.trim(fontFamilyNumber);
      $activePanel.find('#number-font').val(fontFamilyNumber).attr('value', fontFamilyNumber).trigger('value-change');

      // color
      var colorNumber = HELPER.getValueFromCSS($selfNumber, style, 'color', screenType, '.module .num');
      if (colorNumber == '') {
        colorNumber = $selfNumber.css('color');
      }
      $activePanel.find('#number-color').val(colorNumber).attr('value', colorNumber).trigger('value-change');

      // padding-bottom
      var paddingBottomNumber = HELPER.getValueFromCSS($selfNumber, style, 'padding-bottom', screenType);
      if (paddingBottomNumber == '') {
        paddingBottomNumber = $selfNumber.css('padding-bottom');
      }
      $activePanel
        .find('#vertical-gap')
        .val(paddingBottomNumber)
        .attr('value', paddingBottomNumber)
        .trigger('value-change');

      /* Text */
      // font size
      var $selfText = $self.find('.module .count-label');
      var fontSizeText = HELPER.getValueFromCSS($selfText, style, 'font-size', screenType);
      if (fontSizeText == '') {
        fontSizeText = $selfText.css('font-size');
      }

      $activePanel.find('#text-size').val(fontSizeText).attr('value', fontSizeText).trigger('value-change');

      // Font family
      var fontFamilyText = HELPER.getValueFromCSS($selfText, style, 'font-family', screenType);
      fontFamilyText = jQuery.trim(fontFamilyText);
      $activePanel.find('#text-font').val(fontFamilyText).attr('value', fontFamilyText).trigger('value-change');

      // color
      var colorText = HELPER.getValueFromCSS($selfText, style, 'color', screenType, '.module .count-label');
      if (colorText == '') {
        colorText = $selfText.css('color');
      }
      $activePanel.find('#text-color').val(colorText).attr('value', colorText).trigger('value-change');

      /* Horizontal */
      var $selfHorizontal = $self.find('.module .time-left');
      var horizontal = HELPER.getValueFromCSS($selfHorizontal, style, 'padding', screenType);
      if (horizontal == '') {
        horizontal = $selfHorizontal.css('padding');
      }

      $activePanel.find('#horizontal-gap').val(horizontal).attr('value', horizontal).trigger('value-change');
      break;

    case 'Counter':
      // font size
      var fontSize = HELPER.getValueFromCSS($self, style, 'font-size', screenType);
      if (fontSize == '') {
        fontSize = $self.css('font-size');
      }
      $activePanel.find('#font-size').val(fontSize).attr('value', fontSize).trigger('value-change');

      var lineHeight = HELPER.getValueFromCSS($self, style, 'line-height', screenType);
      if ($activePanel.find('#line-height').attr('unit') == 'em') {
        if (lineHeight == '') {
          lineHeight = parseFloat($self.css('line-height'));
          lineHeight = lineHeight / parseFloat(fontSize);
          lineHeight += 'em';
        }
        if (lineHeight.indexOf('px') !== -1) {
          lineHeight = parseFloat(lineHeight);
          lineHeight = lineHeight / parseFloat(fontSize);
          lineHeight += 'em';
        }
      } else if ($activePanel.find('#line-height').attr('unit') == 'px') {
        if (lineHeight == '') {
          lineHeight = $self.css('line-height');
        }
        if (lineHeight.indexOf('em') !== -1) {
          lineHeight = parseFloat(lineHeight);
          lineHeight = fontSize * lineHeight;
          lineHeight += 'px';
        }
      }
      $activePanel.find('#line-height').val(lineHeight).attr('value', lineHeight).trigger('value-change');

      var fontFamily = HELPER.getValueFromCSS($self, style, 'font-family', screenType);
      if (fontFamily == '') {
        fontFamily = $self.css('font-family');
      }
      fontFamily = jQuery.trim(fontFamily);
      $activePanel.find('#font').val(fontFamily).attr('value', fontFamily).trigger('value-change');

      // color
      var color = HELPER.getValueFromCSS($self, style, 'color', screenType);
      /* Not getting from browser css to avoid css overwriting problem from default theme */
      $activePanel.find('#color').val(color).attr('value', color).trigger('value-change');

      var textAlign = HELPER.getValueFromCSS($self, style, 'text-align', screenType, '.module');
      if (textAlign == '') {
        textAlign = $self[0].style.textAlign;
      }
      $activePanel.find('input[name="alignment"]').val(textAlign).attr('value', textAlign).trigger('value-change');

      break;

    case 'Hero Banner':
      var height = HELPER.getValueFromCSS($self, style, 'height', screenType, '.module');
      if (height == '') {
        height = $self[0].style.height;
      }
      $activePanel.find('input[name="height"]').val(height).attr('value', height).trigger('value-change');

      // Lấy ảnh từ css hiển thị sang gfPhotoPicker
      var background = HELPER.getImageBg($self);
      $activePanel.find('input[name="image"]').val(background).attr('value', background).trigger('value-change');

    case 'Tabs':
      var height = HELPER.getValueFromCSS($self, style, 'height', screenType, '.module');
      if (height == '') {
        height = $self[0].style.height;
      }
      $activePanel.find('input[name="height"]').val(height).attr('value', height).trigger('value-change');

      var padding = HELPER.getValueFromCSS(
        $self.find('.gf_tab').find('.item-content'),
        style,
        'padding',
        screenType,
        '> .gf_restabs >ul >li > span:first-child',
      );
      if (padding) {
        const paddingArray = padding.split(' ');
        const paddingX = paddingArray[1] ? paddingArray[1] : '20px';
        const paddingY = paddingArray[0] ? paddingArray[0] : '14px';

        $activePanel.find('input[name="tab-padding-x"]').val(paddingX).attr('value', paddingX).trigger('value-change');
        $activePanel.find('input[name="tab-padding-y"]').val(paddingY).attr('value', paddingY).trigger('value-change');
      }

      break;
    case 'Product List':
      var height = HELPER.getValueFromCSS(
        $self.find('.item-content'),
        style,
        'height',
        screenType,
        '.module>.img-holder',
      );
      var titleHeight = HELPER.getValueFromCSS(
        $self.find('.item-content'),
        style,
        'height',
        screenType,
        '.gf_product-title',
      );

      if (height == undefined || height == 'auto' || height == '') {
        height = '200px';
        $activePanel.find('#sameHeight').val(0).attr('value', 0).trigger('value-change');
      } else {
        $activePanel.find('#sameHeight').val(1).attr('value', 1).trigger('value-change');
      }
      $activePanel.find('#height').val(height).attr('value', height).trigger('value-change');

      //Height (P) Title
      if (titleHeight == undefined || titleHeight == 'auto' || titleHeight == '') {
        titleHeight = '72px';
        $activePanel.find('#sameTitleHeight').val(0).attr('value', 0).trigger('value-change');
      } else {
        $activePanel.find('#sameTitleHeight').val(1).attr('value', 1).trigger('value-change');
      }
      $activePanel.find('#titleHeight').val(titleHeight).attr('value', titleHeight).trigger('value-change');

      break;
    case 'Related Products':
      var imageHeight = HELPER.getValueFromCSS(
        $self.find('.item-content'),
        style,
        'height',
        screenType,
        '.module>.img-holder',
      );
      var titleHeight = HELPER.getValueFromCSS(
        $self.find('.item-content'),
        style,
        'height',
        screenType,
        '.gf_product-title',
      );

      // Height (P) Image
      if (imageHeight == undefined || imageHeight == 'auto' || imageHeight == '') {
        imageHeight = '200px';
        $activePanel.find('#sameImageHeight').val(0).attr('value', 0).trigger('value-change');
      } else {
        $activePanel.find('#sameImageHeight').val(1).attr('value', 1).trigger('value-change');
      }
      $activePanel.find('#imageHeight').val(imageHeight).attr('value', height).trigger('value-change');

      // Height (P) Title
      if (titleHeight == undefined || titleHeight == 'auto' || titleHeight == '') {
        titleHeight = '72px';
        $activePanel.find('#sameTitleHeight').val(0).attr('value', 0).trigger('value-change');
      } else {
        $activePanel.find('#sameTitleHeight').val(1).attr('value', 1).trigger('value-change');
      }
      $activePanel.find('#titleHeight').val(titleHeight).attr('value', titleHeight).trigger('value-change');

      break;
    case '(P) Variants':
      var width = HELPER.getValueFromCSS($self, style, 'width', screenType);
      if (width == '') {
        width = $self[0].style.width;
      }
      $activePanel.find('#width').val(width).attr('value', width).trigger('value-change');

      var height = HELPER.getValueFromCSS($self, style, 'height', screenType);
      if (height == '') {
        height = $self[0].style.height;
      }
      $activePanel.find('#height').val(height).attr('value', height).trigger('value-change');

      /* label */
      var paddingBottom = HELPER.getValueFromCSS($element, style, 'padding-bottom', screenType, 'label');
      if (paddingBottom == '') {
        paddingBottom = $element.find('label').css('padding-bottom');
      }
      $activePanel.find('#label-bottom').val(paddingBottom).attr('value', paddingBottom).trigger('value-change');

      // font size
      var fontSize = HELPER.getValueFromCSS($element, style, 'font-size', screenType, 'label');
      if (fontSize == '') {
        fontSize = $element.find('label').css('font-size');
      }
      $activePanel.find('#label-font-size').val(fontSize).attr('value', fontSize).trigger('value-change');

      var lineHeight = HELPER.getValueFromCSS($element, style, 'line-height', screenType, 'label');
      if ($activePanel.find('#label-line-height').attr('unit') == 'em') {
        if (lineHeight == '') {
          lineHeight = parseFloat($element.find('label').css('line-height'));
          lineHeight = lineHeight / parseFloat(fontSize);
          lineHeight += 'em';
        }
        if (lineHeight.indexOf('px') !== -1) {
          lineHeight = parseFloat(lineHeight);
          lineHeight = lineHeight / parseFloat(fontSize);
          lineHeight += 'em';
        }
      } else if ($activePanel.find('#label-line-height').attr('unit') == 'px') {
        if (lineHeight == '') {
          lineHeight = $element.find('label').css('line-height');
        }
        if (lineHeight.indexOf('em') !== -1) {
          lineHeight = parseFloat(lineHeight);
          lineHeight = fontSize * lineHeight;
          lineHeight += 'px';
        }
      }
      $activePanel.find('#label-line-height').val(lineHeight).attr('value', lineHeight).trigger('value-change');

      var fontFamily = HELPER.getValueFromCSS($element, style, 'font-family', screenType, 'label');
      if (fontFamily == '') {
        fontFamily = $element.find('label').css('font-family');
      }
      fontFamily = jQuery.trim(fontFamily);
      $activePanel.find('#label-font').val(fontFamily).attr('value', fontFamily).trigger('value-change');

      // color
      var color = HELPER.getValueFromCSS($element, style, 'color', screenType, 'label');
      if (color == '') {
        color = $element.find('label').css('color');
      }
      $activePanel.find('#label-color').val(color).attr('value', color).trigger('value-change');

      // min-width label
      if ($activePanel.find('#inlineSpacing').length > 0) {
        var minWidthLabel = HELPER.getValueFromCSS($self, style, 'min-width', screenType, 'label');
        if (minWidthLabel != '' && minWidthLabel != 'auto') {
          $activePanel.find('#inlineSpacing').val(minWidthLabel).attr('value', minWidthLabel).trigger('value-change');
        }
      }
      setFontWeight({ $activePanel, $self, style, screenType, selector: 'label' });
      break;

    case '(P) Swatches':
      var width = HELPER.getValueFromCSS($self, style, 'width', screenType);
      if (width == '') {
        width = $self[0].style.width;
      }
      $activePanel.find('#width').val(width).attr('value', width).trigger('value-change');

      var height = HELPER.getValueFromCSS($self, style, 'height', screenType);
      if (height == '') {
        height = $self[0].style.height;
      }
      $activePanel.find('#height').val(height).attr('value', height).trigger('value-change');

      /* label */
      var paddingBottom = HELPER.getValueFromCSS($element, style, 'padding-bottom', screenType, 'label');
      if (paddingBottom == '') {
        paddingBottom = $element.find('label').css('padding-bottom');
      }
      $activePanel.find('#label-bottom').val(paddingBottom).attr('value', paddingBottom).trigger('value-change');

      var fontSize = HELPER.getValueFromCSS($element, style, 'font-size', screenType, 'label');
      if (fontSize == '') {
        fontSize = $element.find('label').css('font-size');
      }
      $activePanel.find('#label-font-size').val(fontSize).attr('value', fontSize).trigger('value-change');

      var lineHeight = HELPER.getValueFromCSS($element, style, 'line-height', screenType, 'label');
      if ($activePanel.find('#label-line-height').attr('unit') == 'em') {
        if (lineHeight == '') {
          lineHeight = parseFloat($element.find('label').css('line-height'));
          lineHeight = lineHeight / parseFloat(fontSize);
          lineHeight += 'em';
        }
        if (lineHeight.indexOf('px') !== -1) {
          lineHeight = parseFloat(lineHeight);
          lineHeight = lineHeight / parseFloat(fontSize);
          lineHeight += 'em';
        }
      } else if ($activePanel.find('#label-line-height').attr('unit') == 'px') {
        if (lineHeight == '') {
          lineHeight = $element.find('label').css('line-height');
        }
        if (lineHeight.indexOf('em') !== -1) {
          lineHeight = parseFloat(lineHeight);
          lineHeight = fontSize * lineHeight;
          lineHeight += 'px';
        }
      }
      $activePanel.find('#label-line-height').val(lineHeight).attr('value', lineHeight).trigger('value-change');

      var fontFamily = HELPER.getValueFromCSS($element, style, 'font-family', screenType, 'label');
      if (fontFamily !== '') {
        fontFamily = jQuery.trim(fontFamily);
        $activePanel.find('#label-font').val(fontFamily).attr('value', fontFamily).trigger('value-change');
      }
      setFontWeight({ $activePanel, $self, style, screenType, selector: 'label', inputSelector: '#label-font-weight' });

      // color
      var color = HELPER.getValueFromCSS($element, style, 'color', screenType, 'label');
      if (color == '') {
        color = $element.find('label').css('color');
      }
      $activePanel.find('#label-color').val(color).attr('value', color).trigger('value-change');

      // V2
      if ($activePanel.find('#active-outline').length > 0) {
        // Outline
        var shadowActive = HELPER.getValueFromCSS($element, style, 'box-shadow', screenType, '.gf_swatch.gf_selected');
        if (shadowActive == '') {
          shadowActive = $element.find('.gf_swatch.gf_selected').css('box-shadow');
        }
        if (shadowActive != undefined) {
          var shadowVal = shadowActive.match(/-?(\d)+\.(\d+px)|(-?\d+px)|(rgb\(.+\))|(rgba\(.+\))/g);
          if (shadowVal != undefined && shadowVal.length > 0) {
            var shadowColorVal = shadowVal[0];
            var shadowSpread = shadowVal[4];
            shadowColorVal = HELPER.rgb2hex(shadowColorVal);
            $activePanel
              .find('#active-outline-color')
              .attr('value', shadowColorVal)
              .val(shadowColorVal)
              .trigger('value-change');
            $activePanel
              .find('#active-outline-size')
              .attr('value', shadowSpread)
              .val(shadowSpread)
              .trigger('value-change');
          }
        }
      }

      //swatch text
      // font size
      var fontSize = HELPER.getValueFromCSS($self, style, 'font-size', screenType);
      if (fontSize == '') {
        fontSize = $self.css('font-size');
      }
      $activePanel.find('#font-size').val(fontSize).attr('value', fontSize).trigger('value-change');

      var fontFamily = HELPER.getValueFromCSS($self, style, 'font-family', screenType);
      if (fontFamily != '') {
        fontFamily = jQuery.trim(fontFamily);
        $activePanel.find('#font').val(fontFamily).attr('value', fontFamily).trigger('value-change');
      }

      // color
      var color = HELPER.getValueFromCSS($self, style, 'color', screenType);
      $activePanel.find('#color').val(color).attr('value', color).trigger('value-change');
      setFontWeight({ $activePanel, $self, style, screenType });

      break;

    case '(P) Quantity':
      if ($element.attr('data-ver') == '2') {
        // Button width
        const classMinusButton = '.gf_product-quantity-minus';
        const $minusButton = $self.find(classMinusButton);
        let buttonWidth = HELPER.getValueFromCSS($self, style, 'width', screenType, classMinusButton);
        if (buttonWidth == '') {
          buttonWidth = $minusButton.css('width');
        }
        $activePanel.find('#buttonWidth').val(buttonWidth).attr('value', buttonWidth).trigger('value-change');

        // Font size Input
        const classInputQuantiny = '.gf_pq_qty';
        const $inputQuantity = $self.find(classInputQuantiny);
        var fontSize = HELPER.getValueFromCSS($self, style, 'font-size', screenType, classInputQuantiny);
        if (fontSize == '') {
          fontSize = $inputQuantity.css('font-size');
        }
        $activePanel.find('#font-size').val(fontSize).attr('value', fontSize).trigger('value-change');

        // Font size Input
        var fontFamily = HELPER.getValueFromCSS($self, style, 'font-family', screenType, classInputQuantiny);
        if (fontFamily != '') {
          fontFamily = jQuery.trim(fontFamily);
          $activePanel.find('#font').val(fontFamily).attr('value', fontFamily).trigger('value-change');
        }

        // Color Input
        var color = HELPER.getValueFromCSS($self, style, 'color', screenType, classInputQuantiny);
        if (color == '') {
          color = $inputQuantity.css('color');
        }
        $activePanel.find('#color').val(color).attr('value', color).trigger('value-change');

        if (!$self.hasClass('gf_pq-stretch')) {
          var width = HELPER.getValueFromCSS($self, style, 'width', screenType, '.gf_pq_qty');
          if (width == '') {
            width = $self.find('.gf_pq_qty').css('width');
          }
          $activePanel.find('#width').val(width).attr('value', width).trigger('value-change');
        }

        var height = HELPER.getValueFromCSS($self, style, 'height', screenType);
        if (width == '') {
          width = $self.css('height');
        }
        $activePanel.find('#height').val(height).attr('value', height).trigger('value-change');

        // min-width label
        var minWidthLabel = HELPER.getValueFromCSS($self, style, 'min-width', screenType, 'label');
        if (minWidthLabel != '' && minWidthLabel != 'auto') {
          $activePanel
            .find('#label-spacing-inline')
            .val(minWidthLabel)
            .attr('value', minWidthLabel)
            .trigger('value-change');
        }
      } else {
        var fontSize = HELPER.getValueFromCSS($self, style, 'font-size', screenType);
        if (fontSize == '') {
          fontSize = $self.css('font-size');
        }
        $activePanel.find('#font-size').val(fontSize).attr('value', fontSize).trigger('value-change');

        var fontFamily = HELPER.getValueFromCSS($self, style, 'font-family', screenType);
        if (fontFamily == '') {
          // fontFamily = $self.css('font-family');
        }
        fontFamily = jQuery.trim(fontFamily);
        $activePanel.find('#font').val(fontFamily).attr('value', fontFamily).trigger('value-change');

        var color = HELPER.getValueFromCSS($self, style, 'color', screenType);
        if (color == '') {
          color = $self.css('color');
        }
        $activePanel.find('#color').val(color).attr('value', color).trigger('value-change');

        var width = HELPER.getValueFromCSS($self, style, 'width', screenType);
        if (width == '') {
          width = $self[0].style.width;
        }
        $activePanel.find('#width').val(width).attr('value', width).trigger('value-change');

        var height = HELPER.getValueFromCSS($self, style, 'height', screenType);
        if (height == '') {
          height = $self[0].style.height;
        }
        $activePanel.find('#height').val(height).attr('value', height).trigger('value-change');
      }

      /* label */
      var paddingBottom = HELPER.getValueFromCSS($element, style, 'padding-bottom', screenType, 'label');
      if (paddingBottom == '') {
        paddingBottom = $element.find('label').css('padding-bottom');
      }
      $activePanel.find('#label-bottom').val(paddingBottom).attr('value', paddingBottom).trigger('value-change');

      // Label Font Size
      var fontSize = HELPER.getValueFromCSS($element, style, 'font-size', screenType, 'label');
      if (fontSize == '') {
        fontSize = $element.find('label').css('font-size');
      }
      $activePanel.find('#label-font-size').val(fontSize).attr('value', fontSize).trigger('value-change');

      // Label Line Height
      var lineHeight = HELPER.getValueFromCSS($element, style, 'line-height', screenType, 'label');
      if ($activePanel.find('#label-line-height').attr('unit') == 'em') {
        if (lineHeight == '') {
          lineHeight = parseFloat($element.find('label').css('line-height'));
          lineHeight = lineHeight / parseFloat(fontSize);
          lineHeight += 'em';
        }
        if (lineHeight.indexOf('px') !== -1) {
          lineHeight = parseFloat(lineHeight);
          lineHeight = lineHeight / parseFloat(fontSize);
          lineHeight += 'em';
        }
      } else if ($activePanel.find('#label-line-height').attr('unit') == 'px') {
        if (lineHeight == '') {
          lineHeight = $element.find('label').css('line-height');
        }
        if (lineHeight.indexOf('em') !== -1) {
          lineHeight = parseFloat(lineHeight);
          lineHeight = fontSize * lineHeight;
          lineHeight += 'px';
        }
      }
      $activePanel.find('#label-line-height').val(lineHeight).attr('value', lineHeight).trigger('value-change');

      var fontFamily = HELPER.getValueFromCSS($element, style, 'font-family', screenType, 'label');
      fontFamily = jQuery.trim(fontFamily);
      $activePanel.find('#label-font').val(fontFamily).attr('value', fontFamily).trigger('value-change');

      // Label color
      var color = HELPER.getValueFromCSS($element, style, 'color', screenType, 'label');
      if (color == '') {
        color = $element.find('label').css('color');
      }
      setFontWeight({ $activePanel, $self, style, screenType, selector: 'label', inputSelector: '#label-font-weight' });
      setFontWeight({ $activePanel, $self, style, screenType, selector: '.gf_pq_qty' });
      $activePanel.find('#lable-color').val(color).attr('value', color).trigger('value-change');
      break;
    case '(P) Price':
      // font size
      var fontSize = HELPER.getValueFromCSS($self, style, 'font-size', screenType);
      if (fontSize == '') {
        fontSize = $self.css('font-size');
      }
      $activePanel.find('#font-size').val(fontSize).attr('value', fontSize).trigger('value-change');

      var fontFamily = HELPER.getValueFromCSS($self, style, 'font-family', screenType);
      if (fontFamily != '') {
        fontFamily = jQuery.trim(fontFamily);
        $activePanel.find('#font').val(fontFamily).attr('value', fontFamily).trigger('value-change');
      }
      setFontWeight({ $activePanel, $self, style, screenType });
      setFontWeight({
        $activePanel,
        $self,
        style,
        screenType,
        selector: '.gf_product-compare-price',
        inputSelector: '#compare-font-weight',
      });

      // color
      var color = HELPER.getValueFromCSS($self, style, 'color', screenType);
      $activePanel.find('#color').val(color).attr('value', color).trigger('value-change');

      /* Price Color */
      var $compare = $element.find('.gf_product-compare-price');
      if ($compare.length > 0) {
        let compareSize = HELPER.getValueFromCSS($self, style, 'font-size', screenType, '.gf_product-compare-price');
        if (compareSize == '') {
          compareSize = $compare.css('font-size');
        }
        $activePanel.find('#compare-size').val(compareSize).attr('value', compareSize).trigger('value-change');

        let compareColor = HELPER.getValueFromCSS($self, style, 'color', screenType, '.gf_product-compare-price');
        if (compareColor == '') {
          compareColor = HELPER.rgb2hex($compare.css('color'));
        }
        $activePanel.find('#compare-color').val(compareColor).attr('value', compareColor).trigger('value-change');

        // Compare style
        var fontItalic = HELPER.getValueFromCSS($self, style, 'font-style', screenType, '.gf_product-compare-price');
        if (fontItalic == '') {
          fontItalic = $compare.css('font-style');
        }
        if (fontItalic != 'italic') {
          fontItalic = '';
        }

        // Bold
        var fontWeight = HELPER.getValueFromCSS($self, style, 'font-weight', screenType, '.gf_product-compare-price');
        if (fontWeight == '') {
          fontWeight = $compare.css('font-weight');
        }
        if (fontWeight != 'bold') {
          fontWeight = '';
        }
        var fontStyle = fontItalic + ',' + fontWeight;
        $activePanel.find('#compare-style').val(fontStyle).attr('value', fontStyle).trigger('value-change');

        const lineThrough = $activePanel.find('#line-through').val();
        if (lineThrough == '1' || lineThrough == 1) {
          // Color
          let lineThroughColor = HELPER.getValueFromCSS(
            $self,
            style,
            'background',
            screenType,
            '.gf_product-compare-price:after',
          );
          if (lineThroughColor == '') {
            lineThroughColor = compareColor;
          }
          $activePanel
            .find('#line-through-color')
            .attr('value', lineThroughColor)
            .val(lineThroughColor)
            .trigger('value-change');

          // Position
          const lineThroughPosition = HELPER.getValueFromCSS(
            $self,
            style,
            'transform',
            screenType,
            '.gf_product-compare-price:after',
          );
          let lineThroughPositionY = lineThroughPosition.match(/translateY\((-?\d+\.?\d*px)\)/);
          if (lineThroughPositionY && lineThroughPositionY[1]) {
            lineThroughPositionY = lineThroughPositionY[1];
          }
          if (!lineThroughPositionY) {
            lineThroughPositionY = '0px';
          }
          $activePanel
            .find('#line-through-position')
            .attr('value', lineThroughPositionY)
            .val(lineThroughPositionY)
            .trigger('value-change');
        }
      }

      // Price style
      // Italic
      var fontItalic = HELPER.getValueFromCSS($self, style, 'font-style', screenType);
      if (fontItalic == '') {
        fontItalic = $self.css('font-style');
      }
      if (fontItalic != 'italic') {
        fontItalic = '';
      }

      // Bold
      var fontWeight = HELPER.getValueFromCSS($self, style, 'font-weight', screenType);
      if (fontWeight == '') {
        fontWeight = $self.css('font-weight');
      }
      if (fontWeight != 'bold') {
        fontWeight = '';
      }

      // Underline
      var fontUnderline = HELPER.getValueFromCSS($self, style, 'text-decoration', screenType);
      if (fontUnderline == '') {
        fontUnderline = $self.css('text-decoration');
      }
      if (fontUnderline != 'underline') {
        fontUnderline = '';
      }

      var fontStyle = fontItalic + ',' + fontWeight + ',' + fontUnderline;
      $activePanel.find('#font-style').val(fontStyle).attr('value', fontStyle).trigger('value-change');

      /* Percent Discount */
      var classPercent = '.gf_pq-discount';
      var $percent = $element.find(classPercent);
      if ($percent.length > 0) {
        // Padding
        let percentPadding = HELPER.getValueFromCSS($self, style, 'padding-left', screenType, classPercent);
        if (percentPadding == '') {
          percentPadding = $percent.css('padding-left');
        }
        $activePanel
          .find('#percent-discount-padding')
          .val(percentPadding)
          .attr('value', percentPadding)
          .trigger('value-change');

        // Gaps
        let percentGaps = HELPER.getValueFromCSS($self, style, 'padding-left', screenType, '.gf_pq-discount-selector');
        if (percentGaps == '') {
          percentGaps = $element.find('.gf_pq-discount-selector').css('padding-left');
        }
        $activePanel.find('#percent-discount-gaps').val(percentGaps).attr('value', percentGaps).trigger('value-change');

        // Border style
        let percentBorderStyle = HELPER.getValueFromCSS($self, style, 'border-style', screenType, classPercent);
        if (percentBorderStyle == '') {
          percentBorderStyle = $percent.css('border-style');
        }
        $activePanel
          .find('#percent-discount-border-style')
          .val(percentBorderStyle)
          .attr('value', percentBorderStyle)
          .trigger('value-change');

        // Border size
        let percentBorderSize = HELPER.getValueFromCSS($self, style, 'border-width', screenType, classPercent);
        if (percentBorderSize == '') {
          percentBorderSize = $percent.css('border-width');
        }
        $activePanel
          .find('#percent-discount-border-size')
          .val(percentBorderSize)
          .attr('value', percentBorderSize)
          .trigger('value-change');

        // Border color
        let percentBorderColor = HELPER.getValueFromCSS($self, style, 'border-color', screenType, classPercent);
        if (percentBorderColor == '') {
          percentBorderColor = $percent.css('border-color');
        }
        $activePanel
          .find('#percent-discount-border-color')
          .val(percentBorderColor)
          .attr('value', percentBorderColor)
          .trigger('value-change');

        // Font size
        let percentSize = HELPER.getValueFromCSS($self, style, 'font-size', screenType, classPercent);
        if (percentSize == '') {
          percentSize = $percent.css('font-size');
        }
        $activePanel.find('#percent-discount-size').val(percentSize).attr('value', percentSize).trigger('value-change');

        // Font color
        let percentColor = HELPER.getValueFromCSS($self, style, 'color', screenType, classPercent);
        if (percentColor == '') {
          percentColor = HELPER.rgb2hex($percent.css('color'));
        }
        $activePanel
          .find('#percent-discount-color')
          .val(percentColor)
          .attr('value', percentColor)
          .trigger('value-change');

        // Background color
        let percentBgColor = HELPER.getValueFromCSS($self, style, 'background', screenType, classPercent);
        if (percentBgColor == '') {
          percentBgColor = HELPER.rgb2hex($percent.css('background'));
        }
        $activePanel
          .find('#percent-discount-background')
          .val(percentBgColor)
          .attr('value', percentBgColor)
          .trigger('value-change');

        // Font family
        let percentFont = HELPER.getValueFromCSS($self, style, 'font-family', screenType, classPercent);
        if (percentFont != '') {
          percentFont = jQuery.trim(percentFont);
          $activePanel
            .find('#percent-discount-font')
            .val(percentFont)
            .attr('value', percentFont)
            .trigger('value-change');
        }

        // Font style
        // Italic
        let fontPercentItalic = HELPER.getValueFromCSS($self, style, 'font-style', screenType, classPercent);
        if (fontPercentItalic == '') {
          fontPercentItalic = $percent.css('font-style');
        }
        if (fontPercentItalic != 'italic') {
          fontPercentItalic = '';
        }

        // Bold
        let fontPercentWeight = HELPER.getValueFromCSS($self, style, 'font-weight', screenType, classPercent);
        if (fontPercentWeight == '') {
          fontPercentWeight = $percent.css('font-weight');
        }
        if (fontPercentWeight != 'bold') {
          fontPercentWeight = '';
        }

        // Bold
        let fontPercentUnderline = HELPER.getValueFromCSS($self, style, 'text-decoration', screenType, classPercent);
        if (fontPercentUnderline == '') {
          fontPercentUnderline = $percent.css('text-decoration');
        }
        if (fontPercentUnderline != 'underline') {
          fontPercentUnderline = '';
        }

        const fontPercentStyle = fontPercentItalic + ',' + fontPercentWeight + ',' + fontPercentUnderline;
        $activePanel
          .find('#percent-discount-style')
          .val(fontPercentStyle)
          .attr('value', fontPercentStyle)
          .trigger('value-change');
      }
      break;
    case 'Breadcrumbs':
      let symbolSpacing = HELPER.getValueFromCSS($self, style, 'padding-left', screenType, '.gf_breadcrumbs-symbol');
      if (!symbolSpacing) {
        symbolSpacing = $element.find('.gf_breadcrumbs-symbol').css('padding-left');
      }
      $activePanel.find('#spacing-symbol').val(symbolSpacing).attr('value', symbolSpacing).trigger('value-change');

      const $currentPage = $element.find('.gf_breadcrumbs-link.gf_current-page');

      let currentPageFontWeight = HELPER.getValueFromCSS(
        $element,
        style,
        'font-weight',
        screenType,
        '.gf_breadcrumbs-link.gf_current-page',
      );
      if (!currentPageFontWeight) {
        currentPageFontWeight = $currentPage.css('font-weight');
      }
      $activePanel
        .find('#page-font-size')
        .val(currentPageFontWeight)
        .attr('value', currentPageFontWeight)
        .trigger('value-change');

      let currentPageFontSize = HELPER.getValueFromCSS(
        $element,
        style,
        'font-size',
        screenType,
        '.gf_breadcrumbs-link.gf_current-page',
      );
      if (!currentPageFontSize) {
        currentPageFontSize = $currentPage.css('font-size');
      }
      $activePanel
        .find('#page-font-size')
        .val(currentPageFontSize)
        .attr('value', currentPageFontSize)
        .trigger('value-change');

      let currentPageColor = HELPER.getValueFromCSS(
        $element,
        style,
        'color',
        screenType,
        '.gf_breadcrumbs-link.gf_current-page',
      );
      if (!currentPageColor) {
        currentPageColor = $element.find('.gf_breadcrumbs-link.gf_current-page').css('color');
      }
      $activePanel.find('#page-color').val(currentPageColor).attr('value', currentPageColor).trigger('value-change');
    case '(P) Vendor':
    case '(P) SKU':
    case '(P) Title':
    case '(P) Description':
      if (moduleName == '(P) Description') {
        // Letter Spacing
        var letterSpacing = HELPER.getValueFromCSS($self, style, 'letter-spacing', screenType);
        if (letterSpacing == '') {
          letterSpacing = $self.css('letter-spacing');
        }
        $activePanel.find('#letter-spacing').val(letterSpacing).attr('value', letterSpacing).trigger('value-change');
      }
    case '(P) Dynamic Checkout Button':
    case '(P) Cart Button':
    case '(P) View More':
      // Price style
      // Italic
      var fontItalic = HELPER.getValueFromCSS($self, style, 'font-style', screenType);
      if (fontItalic == '') {
        fontItalic = $self.css('font-style');
      }
      if (fontItalic != 'italic') {
        fontItalic = '';
      }

      // Bold
      var fontWeight = HELPER.getValueFromCSS($self, style, 'font-weight', screenType);
      if (fontWeight == '') {
        fontWeight = $self.css('font-weight');
      }
      if (fontWeight != 'bold') {
        fontWeight = '';
      }

      // Underline
      var fontUnderline = HELPER.getValueFromCSS($self, style, 'text-decoration', screenType);
      if (fontUnderline == '') {
        fontUnderline = $self.css('text-decoration');
      }
      if (fontUnderline != 'underline') {
        fontUnderline = '';
      }

      var fontStyle = fontItalic + ',' + fontWeight + ',' + fontUnderline;
      $activePanel.find('#font-style').val(fontStyle).attr('value', fontStyle).trigger('value-change');

    // no break
    case '(P) Image':
    case '(P) Image List':
      if (moduleName == '(P) Image List') {
        // Border active color
        if ($activePanel.find('#border-active').length > 0) {
          // Outline
          var shadowActive = HELPER.getValueFromCSS(
            $element,
            style,
            'box-shadow',
            screenType,
            '.gf_product-image-thumbactive',
          );
          if (shadowActive == '') {
            shadowActive = $element.find('.gf_product-image-thumbactive').css('box-shadow');
          }
          if (shadowActive && shadowActive != '') {
            var shadowVal = shadowActive.match(/-?(\d)+\.(\d+px)|(-?\d+px)|(rgb\(.+\))|(rgba\(.+\))/g);
            if (shadowVal != undefined && shadowVal.length > 0) {
              var shadowColorVal = shadowVal[0];
              var shadowSpread = shadowVal[4];
              shadowColorVal = HELPER.rgb2hex(shadowColorVal);
              $activePanel
                .find('#border-active-color')
                .attr('value', shadowColorVal)
                .val(shadowColorVal)
                .trigger('value-change');
              $activePanel
                .find('#border-active-size')
                .attr('value', shadowSpread)
                .val(shadowSpread)
                .trigger('value-change');
            }
          }
        }
      }
      if (moduleName == '(P) Image') {
        const $badgeAnchor = $self.siblings('.gf_product-badge-anchor');
        const $selector = $self.siblings('.gf_product-badge-anchor').find('.gf_badge-text-wrap');

        // Width and Height
        let badgeWidth = HELPER.getValueFromCSS($self, style, 'width', screenType, '.gf_product-badge-anchor');
        if (!badgeWidth || badgeWidth == '') {
          // badgeWidth = $activePanel.find('#badgeWidth').val();
          badgeWidth = $self.find('.gf_product-badge-anchor').css('width');
        }
        $activePanel.find('#badgeWidth').attr('value', badgeWidth).val(badgeWidth).trigger('value-change');

        let badgeHeight = HELPER.getValueFromCSS($self, style, 'height', screenType, '.gf_product-badge-anchor');
        if (!badgeHeight || badgeHeight == '') {
          badgeHeight = $self.find('.gf_product-badge-anchor').css('height');
        }
        $activePanel.find('#badgeHeight').attr('value', badgeHeight).val(badgeHeight).trigger('value-change');

        // color
        const badgeTextcolor = HELPER.getValueFromCSS($selector, style, 'color', screenType);
        if (color == '') {
          color = HELPER.rgb2hex($selector.css('color'));
        }
        $activePanel.find('#badgeColor').attr('value', badgeTextcolor).val(badgeTextcolor).trigger('value-change');

        // background gradient
        background = HELPER.getValueFromCSS($selector, style, 'background', screenType);
        if (background == '') {
          background = $selector.css('background');
        }
        const matchedString = new RegExp(`rgba*\\((\\d{1,3},\\ *)(\\d{1,3},\\ *)(\\d{1,3})(, \\ *\\d{1,3})*\\)`, 'ig');
        let allRgba = [];
        if (background) {
          allRgba = background.match(matchedString);
        }
        let firstBackgound = 'none';
        let secondBackgound = 'none';
        if (allRgba && allRgba.length > 0) {
          firstBackgound = allRgba[1] ? HELPER.rgb2hex(allRgba[1]) : 'none';
          secondBackgound = allRgba[2] ? HELPER.rgb2hex(allRgba[2]) : 'none';
          $activePanel
            .find('#firstBackgound')
            .attr('value', firstBackgound)
            .val(firstBackgound)
            .trigger('value-change');
          $activePanel
            .find('#secondBackgound')
            .attr('value', secondBackgound)
            .val(secondBackgound)
            .trigger('value-change');
        }

        let badgePositionTransform = HELPER.getValueFromCSS($badgeAnchor, style, 'transform', screenType);
        if (!badgePositionTransform || badgePositionTransform == '') {
          badgePositionTransform = $badgeAnchor.css('transform');
        }
        $activePanel
          .find('#badgePositionTransform')
          .val(badgePositionTransform)
          .attr('value', badgePositionTransform)
          .trigger('value-change');

        // transform (Rotate Frame)
        const rotationFrameInfo = getRotationInfo($badgeAnchor);
        const translateDeg = rotationFrameInfo && rotationFrameInfo.deg ? rotationFrameInfo.deg : 0;
        $activePanel.find('#badgeRotateFrame').val(translateDeg).attr('value', translateDeg).trigger('value-change');
        // transform (Rotate Text)
        const rotationTextInfo = getRotationInfo($badgeAnchor.find('span'));
        const translateTextDeg = rotationTextInfo && rotationTextInfo.deg ? rotationTextInfo.deg : 0;
        $activePanel
          .find('#badgeRotateText')
          .val(translateTextDeg)
          .attr('value', translateTextDeg)
          .trigger('value-change');

        // Saved Money
        const currency = getCurrency($element);
        const displayType = $element.find('.module').attr('data-displaytype');
        const displayUnit = $element.find('.module').attr('data-displayunit');
        if (displayType == 'number') {
          if (currency !== displayUnit) {
            $activePanel.find('#textUnit').val(displayUnit).attr('value', displayUnit).trigger('value-change');
          } else {
            $activePanel.find('#textUnit').val(currency).attr('value', currency).trigger('value-change');
          }
        } else {
          $activePanel.find('#textUnit').val('%').attr('value', '%').trigger('value-change');
        }
      }

    // Không cần break để code tiếp tục chạy xuống dưới.
    case '(P) Meta':

    case '(A) Title':
    case '(A) Content':
    case '(A) Excerpt':
    case '(A) Image':
    case '(A) Date':

    // social share has child items
    /*eslint no-fallthrough: "error"*/
    case 'Social Share':
      // font size
      var fontSize = HELPER.getValueFromCSS($self, style, 'font-size', screenType);
      if (fontSize == '') {
        fontSize = $self.css('font-size');
      }
      $activePanel.find('#font-size').val(fontSize).attr('value', fontSize).trigger('value-change');

      var lineHeight = HELPER.getValueFromCSS($self, style, 'line-height', screenType);
      if ($activePanel.find('#line-height').attr('unit') == 'em') {
        if (lineHeight == '') {
          lineHeight = parseFloat($self.css('line-height'));
          lineHeight = lineHeight / parseFloat(fontSize);
          lineHeight += 'em';
        }
        if (lineHeight.indexOf('px') !== -1) {
          lineHeight = parseFloat(lineHeight);
          lineHeight = lineHeight / parseFloat(fontSize);
          lineHeight += 'em';
        }
      } else if ($activePanel.find('#line-height').attr('unit') == 'px') {
        if (lineHeight == '') {
          lineHeight = $self.css('line-height');
        }
        if (lineHeight.indexOf('em') !== -1) {
          lineHeight = parseFloat(lineHeight);
          lineHeight = fontSize * lineHeight;
          lineHeight += 'px';
        }
      }
      $activePanel.find('#line-height').val(lineHeight).attr('value', lineHeight).trigger('value-change');

      var fontFamily = HELPER.getValueFromCSS($self, style, 'font-family', screenType);
      if (fontFamily == '') {
        // fontFamily = $self.css('font-family');
      }
      fontFamily = jQuery.trim(fontFamily);
      $activePanel.find('#font').val(fontFamily).attr('value', fontFamily).trigger('value-change');

      // Font Weight
      var selector = moduleName == '(A) Title' ? '.gf_article-title' : undefined;
      setFontWeight({ $activePanel, $self, style, screenType, selector });
      // Letter Spacing
      var letterSpacing;
      if (moduleName == '(P) Title') {
        letterSpacing = HELPER.getValueFromCSS($self, style, 'letter-spacing', screenType, '.gf_product-title');
      } else if (moduleName == '(P) Description') {
        letterSpacing = HELPER.getValueFromCSS($self, style, 'letter-spacing', screenType, '.gf_product-desc');
      } else {
        letterSpacing = HELPER.getValueFromCSS($self, style, 'letter-spacing', screenType, '.gf_article-title');
      }

      if (letterSpacing == undefined || letterSpacing == '') {
        letterSpacing = HELPER.rgb2hex($self.find('.gf_article-title').css('letter-spacing'));
      }
      $activePanel.find('#letter-spacing').val(letterSpacing).attr('value', letterSpacing).trigger('value-change');

      //Italic
      var fontItalic = HELPER.getValueFromCSS($self, style, 'font-style', screenType, '.gf_article-title');
      if (fontItalic == '') {
        fontItalic = $self.find('.gf_article-title').css('font-style');
      }
      if (fontItalic != 'italic') {
        fontItalic = '';
      }

      // Underline , strikethrough
      var textDecoration = HELPER.getValueFromCSS($self, style, 'text-decoration', screenType, '.gf_article-title');
      if (textDecoration == '') {
        textDecoration = $self.find('.gf_article-title').css('text-decoration');
      }
      if (!textDecoration || textDecoration == undefined) {
        textDecoration = '';
      }
      if (!textDecoration.includes('underline') && !textDecoration.includes('line-through')) {
        textDecoration = '';
      }

      var fontWeightStyle = '';
      if (fontWeight == 'bold' || parseFloat(fontWeight) == 700) {
        fontWeightStyle = 'bold';
      } else if (parseFloat(fontWeight) < 700) {
        fontWeightStyle = '';
      }
      var fontStyle = fontItalic + ',' + fontWeightStyle + ',' + textDecoration.split(' ');
      fontStyle = fontStyle.trim();
      $activePanel.find('#font-style').val(fontStyle).attr('value', fontStyle).trigger('value-change');

      if (
        moduleName == '(P) Cart Button' ||
        moduleName == '(P) Dynamic Checkout Button' ||
        moduleName == '(P) View More'
      ) {
        let btnColor = HELPER.getValueFromCSS($self, style, 'background-color', screenType);
        if (btnColor == '') {
          if (moduleName == '(P) View More') {
            btnColor = HELPER.rgb2hex($self.css('background-color'));
          } else {
            btnColor = HELPER.rgb2hex($self.css('background-color'));
          }
        }
        $activePanel.find('#button-color').val(btnColor).attr('value', btnColor).trigger('value-change');

        // Hover Options
        let targetClassHover = '.gf_add-to-cart:hover';
        switch (moduleName) {
          case '(P) View More':
            targetClassHover = '.gf_view-more:hover';
            break;
          case '(P) Dynamic Checkout Button':
            targetClassHover = '.shopify-payment-button__button:hover';
            break;
        }

        const btnColorHover = HELPER.getValueFromCSS($self, style, 'background-color', screenType, targetClassHover);
        $activePanel
          .find('#button-color-hover')
          .val(btnColorHover)
          .attr('value', btnColorHover)
          .trigger('value-change');

        const colorHover = HELPER.getValueFromCSS($self, style, 'color', screenType, targetClassHover);
        $activePanel.find('#color-hover').val(colorHover).attr('value', colorHover).trigger('value-change');
      }

      // color
      var color = HELPER.getValueFromCSS($self, style, 'color', screenType);
      if (color == '') {
        if (moduleName == '(P) View More') {
          color = HELPER.rgb2hex($self.css('color'));
        } else {
          color = HELPER.rgb2hex($self.css('color'));
        }
      }
      /* Not getting from browser css to avoid css overwriting problem from default theme */
      $activePanel.find('#color').val(color).attr('value', color).trigger('value-change');

      /* Width & Height */
      var width = HELPER.getValueFromCSS($self, style, 'width', screenType);
      if (width == '') {
        if ($self[0]) {
          width = $self[0].style.width;
        }
      }
      $activePanel.find('#width').val(width).attr('value', width).trigger('value-change');

      var height = HELPER.getValueFromCSS($self, style, 'height', screenType);
      if (height == '') {
        if ($self[0]) {
          height = $self[0].style.height;
        }
      }
      $activePanel.find('#height').val(height).attr('value', height).trigger('value-change');

      break;

    // COLLECTION 2019
    case 'Paginator':
      var fontSize = HELPER.getValueFromCSS($self.find('.pagination'), style, 'font-size', screenType, 'span.page');
      if (fontSize == '') {
        fontSize = $self.find('span.page').css('font-size');
      }
      $activePanel.find('#font-size').val(fontSize).attr('value', fontSize).trigger('value-change');

      var fontItalic = HELPER.getValueFromCSS($self.find('.pagination'), style, 'font-style', screenType, 'span.page');
      if (fontItalic == '') {
        fontItalic = $self.find('span.page').css('font-style');
      }
      if (fontItalic != 'italic') {
        fontItalic = '';
      }

      // Bold
      var fontWeight = HELPER.getValueFromCSS($self.find('.pagination'), style, 'font-weight', screenType, 'span.page');
      if (fontWeight == '') {
        fontWeight = $self.find('span.page').css('font-weight');
      }
      if (fontWeight != 'bold') {
        fontWeight = '';
      }

      // Underline
      var fontUnderline = HELPER.getValueFromCSS(
        $self.find('.pagination'),
        style,
        'text-decoration',
        screenType,
        'span.page',
      );
      if (fontUnderline == '') {
        fontUnderline = $self.find('span.page').css('text-decoration');
      }
      if (fontUnderline != 'underline') {
        fontUnderline = '';
      }

      var fontStyle = fontItalic + ',' + fontWeight + ',' + fontUnderline;
      $activePanel.find('#font-style').val(fontStyle).attr('value', fontStyle).trigger('value-change');

      var layout = HELPER.getValueFromCSS($self.find('.pagination'), style, 'border-style', screenType, 'span.page');
      if (layout == '') {
        layout = $self.find('span.page').css('border-style');
      }
      if (layout == 'solid') {
        layout = 'button';
      } else {
        layout = 'simple';
      }

      $activePanel.find('#layout').val(layout).attr('value', layout).trigger('value-change');

      if (layout == 'button') {
        let btnShape = HELPER.getValueFromCSS(
          $self.find('.pagination'),
          style,
          'border-radius',
          screenType,
          'span.page',
        );
        if (btnShape == '') {
          btnShape = $self.find('span.page').css('border-radius');
        }
        if (btnShape == '0px') {
          btnShape = 'square';
        } else {
          btnShape = 'circle';
        }

        $activePanel.find('#btn-shape').val(btnShape).attr('value', btnShape).trigger('value-change');

        let btnSize = HELPER.getValueFromCSS($self.find('.pagination'), style, 'height', screenType, 'span.page');
        if (btnSize == '' || btnSize == 'auto') {
          btnSize = $self.find('span.page').css('height');
        }
        $activePanel.find('#btn-size').val(btnSize).attr('value', btnSize).trigger('value-change');
      }

      var btnSpacing = $self.find('span.page').css('margin-left');
      if (btnSpacing == '0px') {
        btnSpacing = $self.find('span.page').css('margin-right');
      }
      $activePanel.find('#btn-spacing').val(btnSpacing).attr('value', btnSpacing).trigger('value-change');

      var prevText = $self.find('span.prev').text() || $self.find('[data-previous]').attr('data-previous');
      if (prevText == undefined || prevText == '') {
        prevText = 'PREVIOUS';
      }
      $activePanel.find('#previous_text').val(prevText).attr('value', prevText).trigger('value-change');

      var nextText = $self.find('span.prev').text() || $self.find('[data-next]').attr('data-next');
      if (nextText == undefined || nextText == '') {
        nextText = 'NEXT';
      }
      $activePanel.find('#next').val(nextText).attr('value', nextText).trigger('value-change');

      var textColor = HELPER.getValueFromCSS($self.find('.pagination'), style, 'color', screenType, '.pagination');
      if (textColor == undefined || textColor == '') {
        textColor = $self.find('.pagination').css('color');
      }
      $activePanel.find('#text_color').val(textColor).attr('value', textColor).trigger('value-change');

      var activeColor = HELPER.getValueFromCSS($self.find('.pagination'), style, 'color', screenType, 'span.current');
      if (activeColor == undefined || activeColor == '') {
        activeColor = $self.find('span.page.current').css('color');
      }
      $activePanel.find('#active_color').val(activeColor).attr('value', activeColor).trigger('value-change');

      break;
    case 'Collection Toolbar':
      var width = HELPER.getValueFromCSS(
        $self.find('.gf_collection-toolbar-wrapper'),
        style,
        'width',
        screenType,
        '.gf_collection-toolbar-wrapper',
      );
      $activePanel.find('#width').val(width).attr('value', width).trigger('value-change');

      var height = HELPER.getValueFromCSS(
        $self.find('.gf_collection-toolbar-wrapper'),
        style,
        'height',
        screenType,
        '.gf_collection-toolbar-wrapper',
      );
      if (height == undefined || height == '') {
        height = $self.find('.gf_collection-toolbar-wrapper').css('height');
      }
      $activePanel.find('#height').val(height).attr('value', height).trigger('value-change');

      var quantitySize = HELPER.getValueFromCSS(
        $self.find('.gf_collection-toolbar-wrapper'),
        style,
        'font-size',
        screenType,
        '.gf_product-quantity-wrapper',
      );
      if (quantitySize == undefined || quantitySize == '') {
        quantitySize = $self.find('.gf_product-quantity-wrapper').css('font-size');
      }
      $activePanel.find('#font-size_quantity').val(quantitySize).attr('value', quantitySize).trigger('value-change');

      var quantityColor = HELPER.getValueFromCSS(
        $self.find('.gf_collection-toolbar-wrapper'),
        style,
        'color',
        screenType,
        '.gf_product-quantity-wrapper',
      );
      if (quantityColor == undefined || quantityColor == '') {
        quantityColor = HELPER.rgb2hex($self.find('.gf_product-quantity-wrapper').css('color'));
      }
      $activePanel.find('#color_quantity').val(quantityColor).attr('value', quantityColor).trigger('value-change');

      var quantityFont = HELPER.getValueFromCSS(
        $self.find('.gf_collection-toolbar-wrapper'),
        style,
        'font-family',
        screenType,
        '.gf_product-quantity-wrapper',
      );
      if (quantityFont == undefined || quantityFont == '') {
        quantityFont = HELPER.rgb2hex($self.find('.gf_product-quantity-wrapper').css('font-family'));
      }
      $activePanel.find('#font_quantity').val(quantityFont).attr('value', quantityFont).trigger('value-change');

      var selectorSize = HELPER.getValueFromCSS(
        $self.find('.gf_collection-toolbar-wrapper'),
        style,
        'font-size',
        screenType,
        'select',
      );
      if (selectorSize == undefined || selectorSize == '') {
        selectorSize = $self.find('select').css('font-size');
      }
      $activePanel.find('#font-size_selector').val(selectorSize).attr('value', selectorSize).trigger('value-change');

      var selectorColor = HELPER.getValueFromCSS(
        $self.find('.gf_collection-toolbar-wrapper'),
        style,
        'color',
        screenType,
        'select',
      );
      if (selectorColor == undefined || selectorColor == '') {
        selectorColor = HELPER.rgb2hex($self.find('select').css('color'));
      }
      $activePanel.find('#color_selector').val(selectorColor).attr('value', selectorColor).trigger('value-change');

      var selectorFont = HELPER.getValueFromCSS(
        $self.find('.gf_collection-toolbar-wrapper'),
        style,
        'font-family',
        screenType,
        'select',
      );
      if (selectorFont == undefined || selectorFont == '') {
        selectorFont = HELPER.rgb2hex($self.find('select').css('font-family'));
      }
      $activePanel.find('#font_selector').val(selectorFont).attr('value', selectorFont).trigger('value-change');

      break;
    case 'Collection Banner':
      var height = HELPER.getValueFromCSS($self, style, 'height', screenType, '.module');
      if (height == '') {
        height = $self[0].style.height;
      }
      $activePanel.find('input[name="height"]').val(height).attr('value', height).trigger('value-change');

      // Lấy ảnh từ css hiển thị sang gfPhotoPicker
      var background = HELPER.getImageBg($self);
      $activePanel.find('input[name="image"]').val(background).attr('value', background).trigger('value-change');

      var effect = 'none';
      if ($self.parent().hasClass('effect-zoom')) {
        var effect = 'effect-zoom';
      } else if ($self.parent().hasClass('effect-parallax')) {
        var effect = 'effect-parallax';
      } else {
        var effect = 'none';
      }

      $activePanel.find('input[name="effect"]').val(effect).attr('value', effect).trigger('value-change');

      break;

    case 'Collection Title':
      var fontSize = HELPER.getValueFromCSS(
        $self.find('.gf_collection-title-wrapper'),
        style,
        'font-size',
        screenType,
        '.gf_collection-banner-title h1',
      );
      if (fontSize == undefined || fontSize == '') {
        fontSize = HELPER.rgb2hex($self.find('.gf_collection-banner-title h1').css('font-size'));
      }
      $activePanel.find('#font-size').val(fontSize).attr('value', fontSize).trigger('value-change');

      var lineHeight = HELPER.getValueFromCSS(
        $self.find('.gf_collection-title-wrapper'),
        style,
        'line-height',
        screenType,
        '.gf_collection-banner-title h1',
      );
      if (lineHeight == undefined || lineHeight == '') {
        lineHeight = HELPER.rgb2hex($self.find('.gf_collection-banner-title h1').css('line-height'));
      }
      $activePanel.find('#line-height').val(lineHeight).attr('value', lineHeight).trigger('value-change');

      var letterSpacing = HELPER.getValueFromCSS(
        $self.find('.gf_collection-title-wrapper'),
        style,
        'letter-spacing',
        screenType,
        '.gf_collection-banner-title h1',
      );
      if (letterSpacing == undefined || letterSpacing == '') {
        letterSpacing = HELPER.rgb2hex($self.find('.gf_collection-banner-title h1').css('letter-spacing'));
      }
      $activePanel.find('#letter-spacing').val(letterSpacing).attr('value', letterSpacing).trigger('value-change');

      var color = HELPER.getValueFromCSS(
        $self.find('.gf_collection-title-wrapper'),
        style,
        'color',
        screenType,
        '.gf_collection-banner-title h1',
      );
      if (color == undefined || color == '') {
        color = HELPER.rgb2hex($self.find('.gf_collection-banner-title h1').css('color'));
      }
      $activePanel.find('#text-color').val(color).attr('value', color).trigger('value-change');

      var font = HELPER.getValueFromCSS(
        $self.find('.gf_collection-title-wrapper'),
        style,
        'font-family',
        screenType,
        '.gf_collection-banner-title h1',
      );
      if (font == undefined || font == '') {
        font = HELPER.rgb2hex($self.find('.gf_collection-banner-title h1').css('font-family'));
      }
      $activePanel.find('#font').val(font).attr('value', font).trigger('value-change');

      var textTransform = HELPER.getValueFromCSS(
        $self.find('.gf_collection-title-wrapper'),
        style,
        'text-transform',
        screenType,
        '.gf_collection-banner-title h1',
      );
      if (textTransform == undefined || textTransform == '') {
        textTransform = HELPER.rgb2hex($self.find('.gf_collection-banner-title h1').css('text-transform'));
      }
      $activePanel.find('#textTransform').val(textTransform).attr('value', textTransform).trigger('value-change');

      var fontItalic = HELPER.getValueFromCSS(
        $self.find('.gf_collection-title-wrapper'),
        style,
        'font-style',
        screenType,
        '.gf_collection-banner-title h1',
      );
      if (fontItalic == '') {
        fontItalic = $self.find('.gf_collection-banner-title h1').css('font-style');
      }
      if (fontItalic != 'italic') {
        fontItalic = '';
      }

      // Bold
      var fontWeight = HELPER.getValueFromCSS(
        $self.find('.gf_collection-title-wrapper'),
        style,
        'font-weight',
        screenType,
        '.gf_collection-banner-title h1',
      );
      if (fontWeight == '') {
        fontWeight = $self.find('.gf_collection-banner-title h1').css('font-weight');
      }
      if (fontWeight != 'bold') {
        fontWeight = '';
      }

      // Underline
      var fontUnderline = HELPER.getValueFromCSS(
        $self.find('.gf_collection-title-wrapper'),
        style,
        'text-decoration',
        screenType,
        '.gf_collection-banner-title h1',
      );
      if (fontUnderline == '') {
        fontUnderline = $self.find('.gf_collection-banner-title h1').css('text-decoration');
      }
      if (fontUnderline != 'underline') {
        fontUnderline = '';
      }

      var fontStyle = fontItalic + ',' + fontWeight + ',' + fontUnderline;
      $activePanel.find('#font-style').val(fontStyle).attr('value', fontStyle).trigger('value-change');

      break;

    case 'Collection Desc':
      var fontSize = HELPER.getValueFromCSS(
        $self.find('.gf_collection-description-wrapper'),
        style,
        'font-size',
        screenType,
        '.gf_collection-banner-description',
      );
      if (fontSize == undefined || fontSize == '') {
        fontSize = HELPER.rgb2hex($self.find('.gf_collection-banner-description').css('font-size'));
      }
      $activePanel.find('#font-size').val(fontSize).attr('value', fontSize).trigger('value-change');

      var lineHeight = HELPER.getValueFromCSS(
        $self.find('.gf_collection-description-wrapper'),
        style,
        'line-height',
        screenType,
        '.gf_collection-banner-description',
      );
      if (lineHeight == undefined || lineHeight == '') {
        lineHeight = HELPER.rgb2hex($self.find('.gf_collection-banner-description').css('line-height'));
      }
      $activePanel.find('#line-height').val(lineHeight).attr('value', lineHeight).trigger('value-change');

      var letterSpacing = HELPER.getValueFromCSS(
        $self.find('.gf_collection-description-wrapper'),
        style,
        'letter-spacing',
        screenType,
        '.gf_collection-banner-description',
      );
      if (letterSpacing == undefined || letterSpacing == '') {
        letterSpacing = HELPER.rgb2hex($self.find('.gf_collection-banner-description').css('letter-spacing'));
      }
      $activePanel.find('#letter-spacing').val(letterSpacing).attr('value', letterSpacing).trigger('value-change');

      var color = HELPER.getValueFromCSS(
        $self.find('.gf_collection-description-wrapper'),
        style,
        'color',
        screenType,
        '.gf_collection-banner-description',
      );
      if (color == undefined || color == '') {
        color = HELPER.rgb2hex($self.find('.gf_collection-banner-description').css('color'));
      }
      $activePanel.find('#text-color').val(color).attr('value', color).trigger('value-change');

      var font = HELPER.getValueFromCSS(
        $self.find('.gf_collection-description-wrapper'),
        style,
        'font-family',
        screenType,
        '.gf_collection-banner-description',
      );
      if (font == undefined || font == '') {
        font = HELPER.rgb2hex($self.find('.gf_collection-banner-description').css('font-family'));
      }
      $activePanel.find('#font').val(font).attr('value', font).trigger('value-change');

      var textTransform = HELPER.getValueFromCSS(
        $self.find('.gf_collection-description-wrapper'),
        style,
        'text-transform',
        screenType,
        '.gf_collection-banner-description',
      );
      if (textTransform == undefined || textTransform == '') {
        textTransform = HELPER.rgb2hex($self.find('.gf_collection-banner-description').css('text-transform'));
      }
      $activePanel.find('#textTransform').val(textTransform).attr('value', textTransform).trigger('value-change');

      var fontItalic = HELPER.getValueFromCSS(
        $self.find('.gf_collection-description-wrapper'),
        style,
        'font-style',
        screenType,
        '.gf_collection-banner-description',
      );
      if (fontItalic == '') {
        fontItalic = $self.find('.gf_collection-banner-description').css('font-style');
      }
      if (fontItalic != 'italic') {
        fontItalic = '';
      }

      // Bold
      var fontWeight = HELPER.getValueFromCSS(
        $self.find('.gf_collection-description-wrapper'),
        style,
        'font-weight',
        screenType,
        '.gf_collection-banner-description',
      );
      if (fontWeight == '') {
        fontWeight = $self.find('.gf_collection-banner-description').css('font-weight');
      }
      if (fontWeight != 'bold') {
        fontWeight = '';
      }

      // Underline
      var fontUnderline = HELPER.getValueFromCSS(
        $self.find('.gf_collection-description-wrapper'),
        style,
        'text-decoration',
        screenType,
        '.gf_collection-banner-description',
      );
      if (fontUnderline == '') {
        fontUnderline = $self.find('.gf_collection-banner-description').css('text-decoration');
      }
      if (fontUnderline != 'underline') {
        fontUnderline = '';
      }

      var fontStyle = fontItalic + ',' + fontWeight + ',' + fontUnderline;
      $activePanel.find('#font-style').val(fontStyle).attr('value', fontStyle).trigger('value-change');

      break;
  }
}
